.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
  max-width: 1024px;
  margin: 0 auto;
}

.exploreToolbar {
  display: flex;
  justify-content: flex-start;
  margin-bottom: var(--tuna-spacing-2);
}
